export default "__VITE_ASSET__BsWOepFF__"